import { Injectable } from '@angular/core';

/**
 * Event names reflected in an object for better (and safer) usage.
 */
@Injectable()
export class EventsService {
  public notified = {
    user: {
      logout: 'notified.user.logout',
    },
    document: {},
    directMsg: {
      received: 'notified.directMsg.recevied',
    },
    idea: {
      modalOpened: 'notified.idea.modalOpened',
    },
  };
  public received = {
    action: {
      authentication: {
        login: {
          success: 'received.action.authentication.login.success',
          failure: 'received.action.authentication.login.failure',
        },
      },
      user: {
        create: {
          success: 'received.action.user.create.success',
          failure: 'received.action.user.create.failure',
        },
        changePassword: {
          success: 'received.action.user.changePassword.success',
          failure: 'received.action.user.changePassword.failure',
        },
        forgotPassword: {
          success: 'received.action.user.forgotPassword.success',
          failure: 'received.action.user.forgotPassword.failure',
        },
        delete: {
          success: 'received.action.user.delete.success',
          failure: 'received.action.user.delete.failure',
        },
        update: {
          success: 'received.action.user.update.success',
          failure: 'received.action.user.update.failure',
        },
        notifications: {
          read: {
            success: 'received.action.user.notifications.read.success',
            failure: 'received.action.user.notifications.read.failure',
          },
          seen: {
            success: 'received.action.user.notifications.seen.success',
            failure: 'received.action.user.notifications.seen.failure',
          },
        },
      },
      session: {
        follow: {
          success: 'received.action.session.follow.success',
          failure: 'received.action.session.follow.failure',
        },
        unfollow: {
          success: 'received.action.session.unfollow.success',
          failure: 'received.action.session.unfollow.failure',
        },
        create: {
          success: 'received.action.session.create.success',
          failure: 'received.action.session.create.failure',
        },
        updateConfig: {
          success: 'received.action.session.updateConfig.success',
          failure: 'received.action.session.updateConfig.failure',
        },
        import: {
          success: 'received.action.session.import.success',
          failure: 'received.action.session.import.failure',
        },
        participants: {
          add: {
            success: 'received.action.session.participants.add.success',
            failure: 'received.action.session.participants.add.failure',
          },
          update: {
            success: 'received.action.session.participants.update.success',
            failure: 'received.action.session.participants.update.failure',
          },
          delete: {
            success: 'received.action.session.participants.delete.success',
            failure: 'received.action.session.participants.delete.failure',
          },
        },
        teams: {
          add: {
            success: 'received.action.session.teams.add.success',
            failure: 'received.action.session.teams.add.failure',
          },
        },
        morphbox: {
          addRow: {
            success: 'received.action.session.morphbox.addRow.success',
            failure: 'received.action.session.morphbox.addRow.failure',
          },
          deleteRow: {
            success: 'received.action.session.morphbox.deleteRow.success',
            failure: 'received.action.session.morphbox.deleteRow.failure',
          },
          addElement: {
            success: 'received.action.session.morphbox.addElement.success',
            failure: 'received.action.session.morphbox.addElement.failure',
          },
          deleteElement: {
            success: 'received.action.session.morphbox.deleteElement.success',
            failure: 'received.action.session.morphbox.deleteElement.failure',
          },
        },
        idea: {
          follow: {
            success: 'received.action.session.idea.follow.success',
            failure: 'received.action.session.idea.follow.failure',
          },
          unfollow: {
            success: 'received.action.session.idea.unfollow.success',
            failure: 'received.action.session.idea.unfollow.failure',
          },
          create: {
            success: 'received.action.session.idea.create.success',
            failure: 'received.action.session.idea.create.failure',
          },
          vote: {
            success: 'received.action.session.idea.vote.success',
            failure: 'received.action.session.idea.vote.failure',
          },
          addComment: {
            success: 'received.action.session.idea.addComment.success',
            failure: 'received.action.session.idea.addComment.failure',
          },
          addBenefit: {
            success: 'received.action.session.idea.addBenefit.success',
            failure: 'received.action.session.idea.addBenefit.failure',
          },
          addCollaborator: {
            success: 'received.action.session.idea.addCollaborator.success',
            failure: 'received.action.session.idea.addCollaborator.failure',
          },
          requestCollaboration: {
            success:
              'received.action.session.idea.collaborationRequested.success',
            failure:
              'received.action.session.idea.collaborationRequested.failure',
          },
          approveCollaboration: {
            success:
              'received.action.session.idea.collaborationApproved.success',
            failure:
              'received.action.session.idea.collaborationApproved.failure',
          },
          deleteComment: {
            success: 'received.action.session.idea.deleteComment.success',
            failure: 'received.action.session.idea.deleteComment.failure',
          },
          deleteBenefit: {
            success: 'received.action.session.idea.deleteBenefit.success',
            failure: 'received.action.session.idea.deleteBenefit.failure',
          },
          deleteCollaborator: {
            success: 'received.action.session.idea.deleteCollaborator.success',
            failure: 'received.action.session.idea.deleteCollaborator.failure',
          },
          publish: {
            success: 'received.action.session.idea.publish.success',
            failure: 'received.action.session.idea.publish.failure',
          },
          unpublish: {
            success: 'received.action.session.idea.unpublish.success',
            failure: 'received.action.session.idea.unpublish.failure',
          },
          setMature: {
            success: 'received.action.session.idea.setMature.success',
            failure: 'received.action.session.idea.setMature.failure',
          },
          delete: {
            success: 'received.action.session.idea.delete.success',
            failure: 'received.action.session.idea.delete.failure',
          },
          lock: {
            success: 'received.action.session.idea.lock.success',
            failure: 'received.action.session.idea.lock.failure',
          },
          update: {
            success: 'received.action.session.idea.update.success',
            failure: 'received.action.session.idea.update.failure',
          },
          savePosition: {
            success: 'received.action.session.idea.savePosition.success',
            failure: 'received.action.session.idea.savePosition.failure',
          },
          challenge: {
            add: {
              success: 'received.action.session.idea.challenge.add.success',
              failure: 'received.action.session.idea.challenge.add.failure',
            },
            delete: {
              success: 'received.action.session.idea.challenge.delete.success',
              failure: 'received.action.session.idea.challenge.delete.failure',
            },
            solution: {
              propose: {
                success:
                  'received.action.session.idea.solution.propose.success',
                failure:
                  'received.action.session.idea.solution.propose.failure',
              },
              accept: {
                success: 'received.action.session.idea.solution.accept.success',
                failure: 'received.action.session.idea.solution.accept.failure',
              },
              unaccept: {
                success:
                  'received.action.session.idea.solution.unaccept.success',
                failure:
                  'received.action.session.idea.solution.unaccept.failure',
              },
              delete: {
                success: 'received.action.session.idea.solution.delete.success',
                failure: 'received.action.session.idea.solution.delete.failure',
              },
            },
          },
        },
      },
      tracking: {
        track: {
          success: 'received.action.tracking.track.success',
          failure: 'received.action.tracking.track.failure',
        },
      },
    },
    data: {
      user: {
        me: {
          success: 'received.data.user.me.success',
          failure: 'received.data.user.me.failure',
        },
        all: {
          success: 'received.data.user.all.success',
          failure: 'received.data.user.all.failure',
        },
      },
      session: {
        adminAll: {
          success: 'received.data.session.adminAll.success',
          failure: 'received.data.session.adminAll.failure',
        },
        updateEmailNotifSettings: {
          success: 'received.data.session.updateEmailNotifSettings',
          failure: 'received.data.session.updateEmailNotifSettings',
        },
        all: {
          success: 'received.data.session.all.success',
          failure: 'received.data.session.all.failure',
        },
        single: {
          success: 'received.data.session.single.success',
          failure: 'received.data.session.single.failure',
        },
        report: {
          success: 'received.data.session.report.success',
          failure: 'received.data.session.report.failure',
        },
        export: {
          success: 'received.data.session.export.success',
          failure: 'received.data.session.export.failure',
        },
        idea: {
          single: {
            success: 'received.data.session.idea.single.success',
            failure: 'received.data.session.idea.single.failure',
          },
          singleWithSession: {
            success: 'received.data.session.idea.singleWithSession.success',
            failure: 'received.data.session.idea.singleWithSession.failure',
          },
          editable: {
            success: 'received.data.session.idea.editable.success',
            failure: 'received.data.session.idea.editable.failure',
          },
        },
      },
    },
  };
  public requested = {
    action: {
      authentication: {
        login: 'requested.action.authentication.login',
      },
      user: {
        create: 'requested.action.user.create',
        changePassword: 'requested.action.user.changePassword',
        forgotPassword: 'requested.action.user.forgotPassword',
        delete: 'requested.action.user.delete',
        update: 'requested.action.user.update',
        notifications: {
          read: 'requested.action.user.notification.read',
          seen: 'requested.action.user.notification.seen',
        },
      },
      session: {
        follow: 'requested.action.session.follow',
        unfollow: 'requested.action.session.unfollow',
        create: 'requested.action.session.create',
        updateConfig: 'requested.action.session.updateConfig',
        import: 'requested.action.session.import',
        participants: {
          add: 'requested.action.session.participants.add',
          update: 'requested.action.session.participants.update',
          delete: 'requested.action.session.participants.delete',
        },
        teams: {
          add: 'requested.action.session.teams.add',
        },
        morphbox: {
          addRow: 'requested.action.session.morphbox.addRow',
          addElement: 'requested.action.session.morphbox.addElement',
          deleteRow: 'requested.action.session.morphbox.deleteRow',
          deleteElement: 'requested.action.session.morphbox.deleteElement',
        },
        idea: {
          follow: 'requested.action.session.idea.follow',
          unfollow: 'requested.action.session.idea.unfollow',
          create: 'requested.action.session.idea.create',
          vote: 'requested.action.session.idea.vote',
          addComment: 'requested.action.session.idea.addComment',
          addBenefit: 'requested.action.session.idea.addBenefit',
          addCollaborator: 'requested.action.session.idea.addCollaborator',
          collaborationRequested:
            'requested.action.session.idea.collaborationRequested',
          collaborationApproved:
            'requested.action.session.idea.collaborationApproved',
          deleteComment: 'requested.action.session.idea.deleteComment',
          deleteBenefit: 'requested.action.session.idea.deleteBenefit',
          deleteCollaborator:
            'requested.action.session.idea.deleteCollaborator',
          publish: 'requested.action.session.idea.publish',
          unpublish: 'requested.action.session.idea.unpublish',
          setMature: 'requested.action.session.idea.setMature',
          delete: 'requested.action.session.idea.delete',
          lock: 'requested.action.session.idea.lock',
          update: 'requested.action.session.idea.update',
          savePosition: 'requested.action.session.idea.savePosition',
          challenge: {
            add: 'requested.action.session.idea.challenge.add',
            delete: 'requested.action.session.idea.challenge.delete',
            solution: {
              propose: 'requested.action.session.idea.solution.propose',
              accept: 'requested.action.session.idea.solution.accept',
              unaccept: 'requested.action.session.idea.solution.unaccept',
              delete: 'requested.action.session.idea.solution.delete',
            },
          },
          feedback: {
            post: 'requested.action.session.idea.feedback.post',
          },
        },
      },
      tracking: {
        track: 'requested.action.tracking.track',
      },
    },
    data: {
      user: {
        me: 'requested.data.user.me',
        all: 'requested.data.user.all',
      },
      session: {
        adminAll: 'requested.data.session.adminAll',
        updateEmailNotifSettings:
          'requested.data.session.updateEmailNotifSettings',
        all: 'requested.data.session.all',
        single: 'requested.data.session.single',
        report: 'requested.data.session.report',
        export: 'requested.data.session.export',
        idea: {
          single: 'requested.data.session.idea.single',
          singleWithSession: 'requested.data.session.idea.singleWithSession',
          editable: 'requested.data.session.idea.editable',
        },
      },
    },
  };
  public ui = {
    context: {
      topic: 'ui.context.topic',
    },
  };
}
